import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useEmployeeTransactionAccess } from "../../hooks/useEmployeeTransactionAccess";
import EmployeeTransactionAccessModule from "../../components/modules/EmployeeTransactionAccess/EmployeeTransactionAccessModule";

const EmployeeTransactionAccessPage = ({ user, isHideSideMenu }) => {
  const accessMethods = useEmployeeTransactionAccess();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Employee Transaction Access"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Employee Transaction Access</h3>
            </div>

            <EmployeeTransactionAccessModule
              user={user}
              {...accessMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={accessMethods.showMessage}
        message={accessMethods.message}
        isSuccess={accessMethods.isSuccess}
      />

      <LoadingSpinner loading={accessMethods.loading} />
    </>
  );
};

export default EmployeeTransactionAccessPage;